/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DateList } from '../models/DateList';
import { SportEnum } from '../models/SportEnum';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MatchDayService {
    /**
     * Get Match Dates Today
     * @param areaOfInterestId
     * @param leagueId
     * @param tournamentId
     * @param sports
     * @param subCategoryId
     * @returns DateList Successful Response
     * @throws ApiError
     */
    public static getMatchDatesTodayMatchDayTodayGet(
        areaOfInterestId?: (number | null),
        leagueId?: (number | null),
        tournamentId?: (number | null),
        sports: SportEnum = SportEnum.SOCCER,
        subCategoryId?: (number | null),
    ): CancelablePromise<DateList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/match_day/today',
            query: {
                'area_of_interest_id': areaOfInterestId,
                'league_id': leagueId,
                'tournament_id': tournamentId,
                'sports': sports,
                'sub_category_id': subCategoryId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Match Dates Today V2
     * @param areaOfInterestId
     * @param sports
     * @returns DateList Successful Response
     * @throws ApiError
     */
    public static getMatchDatesTodayV2MatchDayTodayV2Get(
        areaOfInterestId: number,
        sports: SportEnum = SportEnum.SOCCER,
    ): CancelablePromise<DateList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/match_day/today_v2',
            query: {
                'area_of_interest_id': areaOfInterestId,
                'sports': sports,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
